export default {"src":"/_next/static/media/SWEAT.8a5282b5.svg","height":481,"width":651,"blurWidth":0,"blurHeight":0};